<template>
  <div class="weapon-specifications__item">
    <p class="item-title">
      {{ $t('Rarity') }}
    </p>

    <div class="item-labels">
      <button
        v-for="rarity in filters.rarities_count"
        :key="rarity?.name"
        :class="{ active: activeFilters.rarity === rarity?.name }"
        class="item-labels-item btn btn-primary-stroke"
        @click="setFilter('rarity', rarity?.name || '')"
      >
        <span
          :class="`circle-${getModifiedString(rarity?.name)}`"
          class="item-labels-left circle"
        >
          {{ $t(`filters.rarity.${rarity?.name}`) }}
        </span>
        <span
          class="item-labels-right"
        >
          <template v-if="activeFilters.rarity !== rarity?.name">
            {{ rarity?.count || 0 }}
          </template>
          <i
            v-else
            class="i-times"
          />
        </span>
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ItemWeaponPageFiltersResult } from '~/graphql/generated/schema-types';

defineProps<{ filters: ItemWeaponPageFiltersResult }>();
const route = useRoute();
const router = useRouter();

const activeFilters = computed(() => {
  return {
    rarity: route.query.rarity,
  };
});

function setFilter(name: string, value: string | null) {
  const newQuery = { ...route.query };

  if (value === null || value === newQuery[name]) {
    delete newQuery[name];
  } else {
    newQuery[name] = value;
  }

  router.push({ query: newQuery });
}
</script>

<style scoped>

</style>
